/* NOTE: Only import with ssr: false; */
import { List, ListItem, Text } from '@chakra-ui/react';
import {
  FacebookLogoIcon,
  InstagramLogoIcon,
  LinkedinLogoIcon,
  WhatsappLogoIcon,
  YoutubeLogoIcon,
} from '@phosphor-icons/react';
import Link from './Link';

interface SocialShareProps {
  title: string;
}

export const renderIcon = (service: string) => {
  switch (service) {
    case 'Facebook':
      return <FacebookLogoIcon size={34} />;
    case 'Instagram':
      return <InstagramLogoIcon size={34} />;
    case 'Youtube':
      return <YoutubeLogoIcon size={34} />;
    case 'Twitter':
      return (
        <Text as="span" fontSize="32px" fontWeight="bold" lineHeight="1">
          𝕏
        </Text>
      );
    case 'LinkedIn':
      return <LinkedinLogoIcon size={34} />;
    case 'Whatsapp':
      return <WhatsappLogoIcon size={34} />;
    default:
      return null;
  }
};

const SocialShare = ({ title }: SocialShareProps) => {
  if (typeof window === 'undefined') {
    return null;
  }
  const shareLinks = [
    {
      service: 'Twitter',
      link: `https://twitter.com/intent/tweet?text=${title}&url=${window.location.href}`,
    },
    {
      service: 'Facebook',
      link: `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
    },
    {
      service: 'LinkedIn',
      link: `https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`,
    },
    {
      service: 'Whatsapp',
      link: `whatsapp://send?text=${window.location.href}`,
    },
  ];

  return (
    <List display="flex" gridGap={6} py={5}>
      {shareLinks?.map(({ link, service }) => (
        <ListItem color="greenSpruce" key={service}>
          <Link
            href={link}
            display="flex"
            alignItems="center"
            title={service}
            data-test-id={`article-share-${service.toLowerCase()}`}
            _hover={{ textDecoration: 'none' }}
          >
            {renderIcon(service)}
          </Link>
        </ListItem>
      ))}
    </List>
  );
};
export default SocialShare;
